import template from './contact.html';
class ContactController {

}


export default {
    template: template,
    controller: ContactController,
};


// WEBPACK FOOTER //
// ./views/contact/contact.controller.js